import { Container, Message } from './AlertBar.styles'

export type AlertBarVariant = 'success' | 'warning' | 'error'

export interface AlertBarProps {
  variant: AlertBarVariant
  message: string
}

// Full-width tinted bar with a single centered, bold message. Distinct from
// AlertBanner (which has an icon + OK button); see T-C2.
function AlertBar(props: AlertBarProps) {
  const { variant, message } = props

  return (
    <Container $variant={variant}>
      <Message $variant={variant}>{message}</Message>
    </Container>
  )
}

export { AlertBar }
